import Zdog from 'zdog';
import { useContext, useMemo } from 'react';

import {
  IBackgroundGrids,
  IBuildingTree,
  IBuildingVisualization,
  IFloorVisualization,
  IPinScene,
  IPosition3d,
} from 'models';
import { Visualization, VisualizationContext } from './visualization.context';

export const useVisualizationContext = () => {
  return useContext(VisualizationContext);
};

export const useVisualization = () => {
  const { loading_visualization: loading, visualization } = useVisualizationContext();

  return useMemo(() => [loading, visualization] as [boolean, Visualization], [loading, visualization]);
};

export const useVisualizationInfo = () => {
  const [loading, visualization] = useVisualization();

  const axisOffset = visualization?.axisOffset || null;
  const backgroundGrids = visualization?.backgroundGrids || null;
  const buildingTree = visualization?.buildingTree || null;
  const buildingScene = visualization?.buildingScene || null;
  const pinScenes = visualization?.pinScenes || null;

  return [
    {
      loading,
      axisOffset,
      backgroundGrids,
      buildingTree,
      buildingScene,
      pinScenes,
    },
  ] as [
    {
      loading: boolean;
      axisOffset: IPosition3d | null;
      backgroundGrids: IBackgroundGrids | null;
      buildingTree: IBuildingTree | null;
      buildingScene: Zdog.Anchor;
      pinScenes: IPinScene[];
    },
  ];
};

export const useBuildingTree = () => {
  const [{ loading, buildingTree }] = useVisualizationInfo();

  const building = buildingTree?.building || null;
  const floors = buildingTree?.floors || null;

  return [
    {
      loading,
      building,
      floors,
    },
  ] as [
    {
      loading: boolean;
      building: IBuildingVisualization | null;
      floors: Map<number, IFloorVisualization> | null;
    },
  ];
};
